<template>
  <div class="actions">
    <v-tooltip top v-if="permissions.financial.cash_flow.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('edit', value)"
          class="mr-2"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.cashflow.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.financial.cash_flow.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="delete_(value)"
          class="mr-2"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.cashflow.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import bills from '../mixins/index'

export default {
  mixins: [ appdata, bills ],
  props: {
    value: {
      type: Object,
      required: true
    },
    hideView: {
      type: Boolean,
      default: false
    }
  }
}
</script>
